import React from "react";
import { Box } from "@mui/material";
import { Skeleton, Stack } from "@mui/material";

const SkeletonProducts = () => {
  const heightInput = 60;

  return (
    <Box display="flex" flexDirection="column">
      <Stack direction="row" spacing={2}>
        <Skeleton variant="text" width="100%" height={heightInput} />
        <Skeleton variant="text" width="100%" height={heightInput} />
      </Stack>
      <Skeleton variant="rectangular" width="100%" height={420} />
    </Box>
  );
};

export default SkeletonProducts;
